import {
  ActionIcon,
  CopyButton,
  Group,
  NumberInput,
  rem,
  Stack,
  Switch,
  Text,
  TextInput,
  Tooltip,
} from "@mantine/core";
import { Divider } from "@mui/material";
import { IconCopy, IconPercentage, IconTag } from "@tabler/icons-react";
import { useMemo } from "react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { IconCheck } from "@tabler/icons-react";

const WarmupSettings = ({ row, handleSubmit }) => {
  const lang = useLanguage((s) => s.language);
  const settings = useMemo(() => row?.warmup_settings, [row]);

  return (
    <Stack component={"form"} onSubmit={handleSubmit} id="warmup-settings">
      <Switch
        defaultChecked={row.warmup_settings?.warmup_enabled}
        name="warmup_enabled"
        color="green.8"
        label={lang.new_senders.warmup.activate}
        labelPosition="left"
        size="md"
      />
      <Divider />
      <Group>
        <Stack gap={0}>
          <Text>{lang.new_senders.warmup.total}</Text>
          <Text size="sm" c={"dimmed"}>
            {lang.new_senders.warmup.total_text}
          </Text>
        </Stack>
        <NumberInput
          min={1}
          max={50}
          name="total_warmup_per_day"
          w={75}
          ml={"auto"}
          defaultValue={settings?.total_warmup_per_day || 5}
          required
        />
      </Group>
      <Divider />
      <Group>
        <Stack gap={0}>
          <Text>{lang.new_senders.warmup.rampup}</Text>
          <Text size="sm" c={"dimmed"}>
            {lang.new_senders.warmup.rampup_text}{" "}
            <b>{lang.new_senders.warmup.rampup_recommended}</b>
          </Text>
        </Stack>
        <NumberInput
          min={5}
          max={20}
          name="daily_rampup"
          w={75}
          ml={"auto"}
          defaultValue={settings?.daily_rampup || 5}
          required
        />
      </Group>
      <Divider />
      <Group>
        <Stack gap={0}>
          <Text>{lang.new_senders.warmup.answer_rate}</Text>
          <Text size="sm" c={"dimmed"}>
            <b>{lang.new_senders.warmup.answer_recommmended}</b>
          </Text>
        </Stack>
        <NumberInput
          min={20}
          max={50}
          name="reply_rate_percentage"
          w={75}
          ml={"auto"}
          defaultValue={settings?.reply_rate_percentage || 20}
          rightSection={<IconPercentage size={18} />}
          required
        />
      </Group>
      <Divider />
      <Group>
        <Stack gap={0}>
          <Text>{lang.new_senders.warmup.key}</Text>
          <Text size="sm" c={"dimmed"}>
            {lang.new_senders.warmup.key_text}
          </Text>
        </Stack>
        <TextInput
          ml={"auto"}
          value={settings?.keyword}
          leftSection={<IconTag size={18} />}
          readOnly
          rightSection={
            <CopyButton value={settings?.keyword}>
              {({ copied, copy }) => (
                <Tooltip
                  label={copied ? lang.global.copied : lang.global.copy}
                  color={copied ? "teal" : "black"}
                >
                  <ActionIcon
                    color={copied ? "teal" : "primary"}
                    radius="sm"
                    variant="light"
                    onClick={copy}
                  >
                    {copied ? (
                      <IconCheck
                        style={{ width: rem(18), height: rem(18) }}
                        stroke={1.5}
                      />
                    ) : (
                      <IconCopy
                        style={{ width: rem(18), height: rem(18) }}
                        stroke={1.5}
                      />
                    )}
                  </ActionIcon>
                </Tooltip>
              )}
            </CopyButton>
          }
        />
      </Group>
    </Stack>
  );
};

export default WarmupSettings;
